<template>
  <div>
    <div class="container">
      <affiliate-policy-content></affiliate-policy-content>
    </div>
  </div>
</template>

<script>
  import AffiliatePolicyContent from '../../components/affiliatePolicy/AffiliatePolicy.vue'

  export default {
    name: 'affiliate-policy',
    components: {
      AffiliatePolicyContent
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// Index.vue?d5c5eee8